<div class="header">
  <h3 class="h3-semibold">{{ title }}</h3>
  <img (click)="closeDialog()" style="margin-left: auto; width: 24px; height: 24px" [src]="iconService.Icon.cross" />
</div>
<div class="img-list">
  <ng-container *ngFor="let item of iconList">
    <img (click)="selectIcon(item)" width="40px" height="40px" [ngStyle]="{ background: currentIcon === item ? '#dfdfdf' : 'transparent', border: currentIcon === item ? '1px solid #4f356e' : '1px solid transparent' }" [ngClass]="item === selectedIcon ? 'blue-highlight' : ''" [src]="item" />
  </ng-container>
</div>
<div class="bottom">
  <ag-button-v2 size="large" type="tertiary" label="Cancel" (click)="closeDialog()"></ag-button-v2>
  <ag-button-v2 size="large" [disabled]="!canSave()" specificWidth="184px" type="primary" label="Select" (click)="save()"></ag-button-v2>
</div>
